import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { workerMessages as e } from "../../kernel.js";
import t from "../Error.js";
import o from "../Logger.js";
import { onAbortOrThrow as s, isPromiseLike as r, isAbortError as n } from "../promiseUtils.js";
import { newJobId as a, receiveMessage as i, toInvokeError as l, postMessage as d, MessageType as h } from "./utils.js";
import { createWorker as c } from "./workerFactory.js";
var p = o.getLogger("esri.core.workers"),
    b = h.ABORT,
    m = h.INVOKE,
    _ = h.OPEN,
    u = h.OPENED,
    g = h.RESPONSE;

var j = /*#__PURE__*/function () {
  function j(e, t) {
    _classCallCheck(this, j);

    this._outJobs = new Map(), this._inJobs = new Map(), this.worker = e, this.id = t, e.addEventListener("message", this._onMessage.bind(this)), e.addEventListener("error", function (e) {
      e.preventDefault(), p.error(e);
    });
  }

  _createClass(j, [{
    key: "terminate",
    value: function terminate() {
      this.worker.terminate();
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _this = this;

        var t,
            o,
            r,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                o = t.signal, r = a();
                return _context.abrupt("return", new Promise(function (t, n) {
                  var a = {
                    resolve: t,
                    reject: n,
                    abortHandle: s(o, function () {
                      _this._outJobs.delete(r), _this._post({
                        type: b,
                        jobId: r
                      });
                    })
                  };
                  _this._outJobs.set(r, a), _this._post({
                    type: _,
                    jobId: r,
                    modulePath: e
                  });
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function open(_x) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "_onMessage",
    value: function _onMessage(e) {
      var t = i(e);
      if (t) switch (t.type) {
        case u:
          this._onOpenedMessage(t);

          break;

        case g:
          this._onResponseMessage(t);

          break;

        case b:
          this._onAbortMessage(t);

          break;

        case m:
          this._onInvokeMessage(t);

      }
    }
  }, {
    key: "_onAbortMessage",
    value: function _onAbortMessage(e) {
      var t = this._inJobs,
          o = e.jobId,
          s = t.get(o);
      s && (s.controller && s.controller.abort(), t.delete(o));
    }
  }, {
    key: "_onInvokeMessage",
    value: function _onInvokeMessage(t) {
      var _this2 = this;

      var o = t.methodName,
          s = t.jobId,
          a = t.data,
          i = t.abortable,
          d = i ? new AbortController() : null,
          h = this._inJobs,
          c = e[o];
      var p;

      try {
        if ("function" != typeof c) throw new TypeError("".concat(o, " is not a function"));
        p = c.call(null, a, {
          signal: d ? d.signal : null
        });
      } catch (b) {
        return void this._post({
          type: g,
          jobId: s,
          error: l(b)
        });
      }

      r(p) ? (h.set(s, {
        controller: d,
        promise: p
      }), p.then(function (e) {
        h.has(s) && (h.delete(s), _this2._post({
          type: g,
          jobId: s
        }, e));
      }, function (e) {
        h.has(s) && (h.delete(s), e || (e = {
          message: "Error encountered at method" + o
        }), n(e) || _this2._post({
          type: g,
          jobId: s,
          error: l(e || {
            message: "Error encountered at method ".concat(o)
          })
        }));
      })) : this._post({
        type: g,
        jobId: s
      }, p);
    }
  }, {
    key: "_onOpenedMessage",
    value: function _onOpenedMessage(e) {
      var t;

      var o = e.jobId,
          s = e.data,
          r = this._outJobs.get(o);

      r && (this._outJobs.delete(o), null == (t = r.abortHandle) || t.remove(), r.resolve(s));
    }
  }, {
    key: "_onResponseMessage",
    value: function _onResponseMessage(e) {
      var o;

      var s = e.jobId,
          r = e.error,
          n = e.data,
          a = this._outJobs.get(s);

      a && (this._outJobs.delete(s), null == (o = a.abortHandle) || o.remove(), r ? a.reject(t.fromJSON(JSON.parse(r))) : a.resolve(n));
    }
  }, {
    key: "_post",
    value: function _post(e, t, o) {
      return d(this.worker, e, t, o);
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return c();

              case 2:
                t = _context2.sent;
                return _context2.abrupt("return", new j(t, e));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return j;
}();

export { j as default };